import { message } from "antd";
import axios from "../axios-interceptor.js"


let tenantId = localStorage.getItem("tenantId")
const BACKEND_API = process.env.REACT_APP_BACKEND_API;

export const sendVerifyMail = async (email) => {
    let responseObj = { success: false, message: '' };
    await axios({
        method: "POST",
        url: `${BACKEND_API}/verify-email?email=${email}`,
        data: {}
    })
        .then((response) => {
            if (response.status === 200) {
                responseObj.success = true
            } else {
                responseObj.message = response.data.message
            }
        })
        .catch((error) => {
        });
    return responseObj;

}

export const userSignup = async (postData, method = "POST", tenantId = "") => {
    let responseObj = { success: false, message: '' };
    let headerObj = {}
    if (tenantId) {
        headerObj.tenantId = tenantId
    }
    await axios({
        method: method,
        url: `${BACKEND_API}/signup`, //?direct=true in case of gmail signup
        data: postData,
        headers: headerObj
    })
        .then((response) => {
            if (response.status === 200) {
                responseObj.success = true
                responseObj.data = response.data
            }
            responseObj.message = response.data.message
        })
        .catch((error) => {
        });
    return responseObj;

}

export const userConfirmationVerification = async (email, info) => {
    let responseObj = { success: false, message: '' };
    await axios({
        method: "GET",
        url: `${BACKEND_API}/verify?email=${email}&info=${info}`,
        data: {}
    })
        .then((response) => {
            if (response.status === 200) {
                responseObj.success = true
            }
            responseObj.status = response.status
            responseObj.message = response.data.message
        })
        .catch((error) => {
        });
    return responseObj;

}

// The backend reports an expired password as `passwordExpired: true`. Accept it
// either nested under `result` or at the top level of the body. Matched strictly
// so that a stringified "false" is never read as expired.
const isFlagSet = (value) => value === true || value === "true";

const isPasswordExpired = (body) =>
    isFlagSet(body?.result?.passwordExpired) || isFlagSet(body?.passwordExpired);

export const loginUser = async (postData, isGoogle = false, idToken = "") => {
    let responseObj = { success: false, message: '', passwordExpired: false };

    let url = `${BACKEND_API}/login`;
    let headerObj = {};
    if (isGoogle) {
        url += '?isGoogleLogin=true'
        // No session exists yet, so the Google ID token itself is the credential
        // the backend verifies. The interceptor only fills Authorization in when
        // the request has not set it, so this is what gets sent.
        if (idToken) {
            headerObj.Authorization = idToken
        }
    } else {
        url += '?isPasswordLogin=true'
    }


    // companyIdentifier header is added automatically by axios interceptor
    // skipAuthRefresh: there is no session yet, so a 401/403 here must not
    // trigger the interceptor's token refresh or its "Session expired" logout —
    // an expired password comes back on this call and has to reach the caller.
    await axios({
        method: "POST",
        url: url,
        data: postData,
        headers: headerObj,
        skipAuthRefresh: true
    })
        .then((response) => {
            const result = response.data?.result
            responseObj.data = result
            responseObj.status = response.status
            responseObj.message = response.data?.message || "Failed to login. Please try again."
            responseObj.passwordExpired = isPasswordExpired(response.data)

            // An expired password must not establish a session, even if the API
            // still returns a token alongside the flag.
            if (responseObj.passwordExpired) {
                return
            }

            // Only set success if we got an accessToken (actual successful login)
            if (result?.accessToken) {
                responseObj.success = true
                localStorage.setItem('accessToken', result.accessToken)
                localStorage.setItem('tenantId', result.tenantId)
                window.dispatchEvent(new Event("storage"));
            }
        })
        .catch((error) => {
            // The expiry flag may arrive on an error status (401/403) rather
            // than a 200, so read it off the error payload too.
            const errorData = error?.response?.data
            responseObj.status = error?.response?.status
            responseObj.data = errorData?.result
            responseObj.message = errorData?.message || "Unable to login. Please try again."
            responseObj.passwordExpired = isPasswordExpired(errorData)
        });
    return responseObj;

}